import { LevelConfig, Fragment, generateFragmentPairHints } from './levelSystem';

const bach784Fragments: Fragment[] = [
  {
    id: 'fragment_784_1',
    name: 'Fragment 1',
    voice: 'right',
    beatDuration: 4,
    notes: [
      { note: 'rest', time: '0:0:0', duration: '16n' },
      { note: 'E4', time: '0:0:1', duration: '16n' },
      { note: 'A4', time: '0:0:2', duration: '16n' },
      { note: 'C5', time: '0:0:3', duration: '16n' },
      { note: 'B4', time: '0:1:0', duration: '16n' },
      { note: 'E4', time: '0:1:1', duration: '16n' },
      { note: 'B4', time: '0:1:2', duration: '16n' },
      { note: 'D5', time: '0:1:3', duration: '16n' },
      { note: 'C5', time: '0:2:0', duration: '8n' },
      { note: 'E5', time: '0:2:2', duration: '8n' },
      { note: 'G#4', time: '0:3:0', duration: '8n' },
      { note: 'E5', time: '0:3:2', duration: '8n' }
    ],
    correctPosition: {
      beat: 0,
      pitch: 0
    }
  },
  {
    id: 'fragment_784_2',
    name: 'Fragment 2',
    voice: 'left',
    beatDuration: 4,
    notes: [
      { note: 'A2', time: '0:0:0', duration: '8n' },
      { note: 'A3', time: '0:0:2', duration: '4n' },
      { note: 'G#3', time: '0:1:2', duration: '8n' },
      { note: 'A3', time: '0:2:0', duration: '16n' },
      { note: 'C3', time: '0:2:1', duration: '16n' },
      { note: 'A3', time: '0:2:2', duration: '16n' },
      { note: 'C4', time: '0:2:3', duration: '16n' },
      { note: 'B3', time: '0:3:0', duration: '16n' },
      { note: 'E3', time: '0:3:1', duration: '16n' },
      { note: 'B3', time: '0:3:2', duration: '16n' },
      { note: 'D4', time: '0:3:3', duration: '16n' }
    ],
    correctPosition: {
      beat: 0,
      pitch: 0
    }
  },
  {
    id: 'fragment_784_3',
    name: 'Fragment 3',
    voice: 'right',
    beatDuration: 3,
    notes: [
      { note: 'A4', time: '0:0:0', duration: '16n' },
      { note: 'E4', time: '0:0:1', duration: '16n' },
      { note: 'A4', time: '0:0:2', duration: '16n' },
      { note: 'C5', time: '0:0:3', duration: '16n' },
      { note: 'B4', time: '0:1:0', duration: '16n' },
      { note: 'E4', time: '0:1:1', duration: '16n' },
      { note: 'B4', time: '0:1:2', duration: '16n' },
      { note: 'D5', time: '0:1:3', duration: '16n' },
      { note: 'C5', time: '0:2:0', duration: '8n' },
      { note: 'A4', time: '0:2:2', duration: '8n' }
    ],
    correctPosition: {
      beat: 4,
      pitch: 0
    }
  },
  {
    id: 'fragment_784_4',
    name: 'Fragment 4',
    voice: 'left',
    beatDuration: 4,
    notes: [
      { note: 'C4', time: '0:0:0', duration: '8n' },
      { note: 'A3', time: '0:0:2', duration: '8n' },
      { note: 'G#3', time: '0:1:0', duration: '8n' },
      { note: 'E3', time: '0:1:2', duration: '8n' },
      { note: 'A3', time: '0:2:0', duration: '16n' },
      { note: 'E3', time: '0:2:1', duration: '16n' },
      { note: 'A3', time: '0:2:2', duration: '16n' },
      { note: 'C4', time: '0:2:3', duration: '16n' },
      { note: 'B3', time: '0:3:0', duration: '16n' },
      { note: 'E3', time: '0:3:1', duration: '16n' },
      { note: 'B3', time: '0:3:2', duration: '16n' },
      { note: 'D4', time: '0:3:3', duration: '16n' }
    ],
    correctPosition: {
      beat: 4,
      pitch: 0
    }
  }
];

export const bachInvention784Level: LevelConfig = {
  id: 'bach_invention_784',
  name: 'Bach Invention No. 13',
  description: 'Reconstruct the opening of Bach\'s Invention No. 13 in A Minor',

  // Timeline Configuration
  totalBeats: 8,              // 8 beats total
  tempo: 104,                 // BPM
  key: 'A Minor',             // A Minor
  timeSignature: [4, 4],      // 4/4 time

  // Fragment Configuration
  fragments: bach784Fragments,

  // Solution Hints - auto-generated for all fragment pairs
  solutionHints: generateFragmentPairHints(bach784Fragments),

  // Difficulty/Hints
  showBeatNumbers: true,
  allowPartialSolutions: false,
};